import { deviceType } from "../../components/Helper";
import link from "../../data/links.json";
import warnings from "../../data/warnings.json";

export const Summary = (props: any) => {
    const dType: any = deviceType
    const type: string = props?.type;
    const mcu = props?.mcu;
    const ext = props?.ext;
    const getDeviceLink = () => {
        const data: any = link;
        if (data[type][mcu]) return data[type][mcu];
        return "";
    }

    const getExtensionLink = () => {
        const data: any = link;
        if (data["extensions"][ext]) return data["extensions"][ext];
        return "";
    }

    const getWarnings = () => {
        const wInfo: any = warnings;
        return <div>
            {wInfo?.common[type]?.warnings || wInfo?.device[type]?.warnings || wInfo?.extensions[ext]?.warnings ? <h5 className="mt-1 mb-1">Info:</h5> : ""}
            <ul className="inst-list mt-1 mb-1">
                {wInfo?.common[type] && wInfo?.common[type]?.warnings ? <li>{wInfo?.common[type]?.warnings}</li> : ""}
                {wInfo?.device[type] && wInfo?.device[type][mcu]?.warnings ?
                    wInfo?.device[type][mcu]?.warnings?.map((warning: string) => <li>{warning}</li>)
                    : ""}
                {wInfo?.extensions[ext] && wInfo?.extensions[ext]?.warnings ?
                    wInfo?.extensions[ext]?.warnings?.map((warning: string) => <li>{warning}</li>)
                    : ""}
            </ul>
        </div>
    }

    return <div className="text-left summary">
        <h4 className="mt-1 mb-1">Example connection:</h4>
        <img className={`touch-adapter-img ${dType[type]?.toLowerCase()?.replaceAll(" ", "_")}`} src={`${process.env.PUBLIC_URL}/images/${dType[type]?.replaceAll(" ", "_")}/${ext}.jpg`} alt={`kit-touch-adapter-${ext}-extenstion-connection`} />
        <h4 className="mt-1 mb-1">Description</h4>
        <span>This tool helps in identifying the correct pins for connecting the Touch Sensor Board to Curiosity Pro or Curiosity Nano boards. Since Curiosity Nano Boards cannot be directly connected to Touch Extension boards, the CNANO Touch Adaptor board is required to serve as an intermediary between Curiosity Nano MCU boards and Touch Extension Boards.</span>
        <h4 className="mt-1 mb-1">Instructions</h4>
        <ul className="inst-list mt-1 mb-1">
            <li>Select the preferred type of category i.e Curiosity Nano / Curiosity Pro MCU from the type list in the toolbar</li>
            <li>Select the preferred Curiosity Nano / Curiosity Pro MCU from the list of MCU's in the toolbar</li>
            <li>Select the preferred extension from the list of extensions in the toolbar dropdow</li>
            <li>Check on either the table or visual pin mapping conversions.<br /> <strong>Note: </strong>Switch to the Advanced View to view the visual pin mappings.</li>
        </ul>
        <h4 className="mt-1 mb-1">Kit Information</h4>
        <p className="mt-1 mb-1">
            <span>Click to know more information about:{"  "}</span>
            <ul>
                <li>MCU :{" "}<a href={getDeviceLink()} target="_blank" rel="noreferrer">{mcu}</a>{"  "} </li>
                <li>Extension :{"  "}<a href={getExtensionLink()} target="_blank" rel="noreferrer">{ext?.replaceAll("_", " ")}</a></li>
            </ul>
        </p>
        {getWarnings()}
    </div>
}